export { DEFAULT_DROPBOX_SOURCE_URL } from '../../../common/constants'

export const validEmailRecipientRegex = new RegExp(
  "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$",
)
export const validDomainRegex = new RegExp('^[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+$')
